import React from 'react';
import { motion } from 'framer-motion';
import { videoHighlights } from '../data/siteContent';

const VideoGallery = () => {
  return (
    <section className="video-gallery-section">
      <div className="container">
        <span className="section-kicker">Authentic video highlights</span>
        <h2 className="section-title">Video Gallery</h2>
        <div className="video-showcase-grid">
          {videoHighlights.map((video, index) => (
            <motion.div
              key={video.id}
              className="video-showcase-card"
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1, duration: 0.45 }}
            >
              <video className="showcase-video" controls preload="metadata" poster={video.poster}>
                <source src={video.src} type="video/mp4" />
              </video>
              <p className="video-title">{video.title}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default VideoGallery;
